import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const CollabCTA = ({
  title = "Your Brand Deserves to Be Seen Beautifully.",
  text = "Have a product, collection or campaign in mind? Let's create something meaningful together.",
}) => (
  <section data-testid="collab-cta-section" className="relative overflow-hidden bg-wine text-ivory grain">
    <div className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
      <Reveal className="max-w-4xl">
        <p className="eyebrow text-champagne">Collaborate</p>
        <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] md:text-6xl lg:text-7xl">{title}</h2>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-ivory/85 md:text-lg">{text}</p>
        <Link to="/contact" className="btn btn-ivory mt-12" data-testid="collab-cta-request-quote">
          Request a Quote
        </Link>
      </Reveal>
      <span aria-hidden className="pointer-events-none absolute -bottom-10 right-4 select-none font-serif text-[9rem] leading-none text-ivory/[0.06] md:text-[18rem]">
        BWI
      </span>
    </div>
  </section>
);
